import React from 'react';

import { useSnackbar } from 'notistack';
import { Controller, useForm } from 'react-hook-form';

import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { Button, FormControlLabel, FormGroup, Stack, Switch } from '@mui/material';

import { SettingsFormData } from '~/components/SupportAssistant/pages/Settings/settings';

import { useUpdateSettings } from '~/hooks/apis/support/useSettings';

interface Props {
  settings: SettingsFormData | null;
  onError: (error: Error) => void;
}

export function SettingsForm({ settings, onError }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const updateSettings = useUpdateSettings();

  const { control, handleSubmit } = useForm<SettingsFormData>({
    defaultValues: settings,
  });

  const onSubmit = async (data: SettingsFormData) => {
    try {
      await updateSettings.mutateAsync({
        values: {
          ...settings,
          ...data,
        },
      });
      enqueueSnackbar('Settings successfully updated', { variant: 'success' });
    } catch (error) {
      onError(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack direction="column" spacing={2}>
        <FormGroup>
          <Controller
            control={control}
            name="GENESYS.enabled"
            render={({ field }) => (
              <FormControlLabel control={<Switch {...field} checked={field.value} />} label="Genesys" />
            )}
          />
        </FormGroup>
        <FormGroup>
          <Controller
            control={control}
            name="CHRISTMAS.enabled"
            render={({ field }) => (
              <FormControlLabel control={<Switch {...field} checked={field.value} />} label="Christmas" />
            )}
          />
        </FormGroup>
      </Stack>
      <Stack direction="row" mt={2} spacing={2}>
        <Button
          disabled={updateSettings.isPending}
          type="submit"
          variant="contained"
          startIcon={updateSettings.isPending ? <HourglassTopIcon /> : <SettingsApplicationsIcon />}
        >
          Save
        </Button>
      </Stack>
    </form>
  );
}
